import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default {
  namespaced: true,
    state: {
      posts: [],
      byCategory: {}
  },
  mutations: {
    setCategory(state, args) {
      args.forEach(element => {
        state.byCategory[element.Iso] = {
          name: element.Label,
          slug: element.Iso,
          hotTopic: null,
          posts: []
        };
      });
    },
    setPosts(state, args) {
      state.posts = args
      state.posts.forEach(element => {
        Object.keys(state.byCategory).forEach(function (key) {
          if (element.postCategory === state.byCategory[key].slug) {
            if (element.IsHotTopic === true ) (state.byCategory[key].hotTopic = element)
            state.byCategory[key].posts.push(element)
          }
        })
      })
      Object.keys(state.byCategory).forEach(function (key) {
        if (!state.byCategory[key].hotTopic) (state.byCategory[key].hotTopic = state.byCategory[key].posts[0])
      })
    },
  },
  actions: {
    async getCategory({commit}) {
      axios.get('/strapi/posts-categories')
      .then( (res) => {
        commit('setCategory', res.data)
      })
      .catch( (err) => {
        console.log(err)
      })
    },
    async getPosts({commit}) {
      axios.get('/strapi/posts')
      .then( (res) => {
        commit('setPosts', res.data.reverse())
      })
      .catch( (err) => {
        console.log(err)
      })
    },
  },
  getters: {
    posts: state => state.posts,
    categorys: stable => stable.byCategory,
  }
}